var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-system-notification-global.lit.scss';
import styles from './sds-system-notification.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * `sds-system-notification` represents a system notification component with options for button and checkbox actions.
 *
 * ### Attributes
 * - `type`: Specifies the notification type, affecting its style and purpose.
 * - `with-button`: Determines if the notification includes an action button.
 * - `with-checkbox`: Determines if the notification includes a checkbox action.
 *
 * @tag sds-system-notification
 */
let SdsSystemNotification = (() => {
    var _SdsSystemNotification_type_accessor_storage, _SdsSystemNotification_withButton_accessor_storage, _SdsSystemNotification_withCheckbox_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-system-notification')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _withButton_decorators;
    let _withButton_initializers = [];
    let _withButton_extraInitializers = [];
    let _withCheckbox_decorators;
    let _withCheckbox_initializers = [];
    let _withCheckbox_extraInitializers = [];
    var SdsSystemNotification = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsSystemNotification_type_accessor_storage.set(this, __runInitializers(this, _type_initializers, 'success'));
            _SdsSystemNotification_withButton_accessor_storage.set(this, (__runInitializers(this, _type_extraInitializers), __runInitializers(this, _withButton_initializers, false)));
            _SdsSystemNotification_withCheckbox_accessor_storage.set(this, (__runInitializers(this, _withButton_extraInitializers), __runInitializers(this, _withCheckbox_initializers, false)));
            this._stylesGlobal = (__runInitializers(this, _withCheckbox_extraInitializers), stylesGlobal);
        }
        /**
         * Specifies the notification type, affecting its style and purpose.
         *
         * Possible values:
         * - `'success'`: Indicates a successful action or message.
         * - `'info'`: Provides informational feedback to the user.
         * - `'warning'`: Highlights a caution or potential issue.
         * - `'error'`: Denotes an error or critical message.
         *
         * @attr {string} type - The type of the system notification. Defaults to 'success'.
         */
        get type() { return __classPrivateFieldGet(this, _SdsSystemNotification_type_accessor_storage, "f"); }
        set type(value) { __classPrivateFieldSet(this, _SdsSystemNotification_type_accessor_storage, value, "f"); }
        /**
         * Determines if the notification includes an action button.
         *
         * @attr {boolean} with-button - If `true`, the notification includes a button for additional actions. Defaults to `false`.
         */
        get withButton() { return __classPrivateFieldGet(this, _SdsSystemNotification_withButton_accessor_storage, "f"); }
        set withButton(value) { __classPrivateFieldSet(this, _SdsSystemNotification_withButton_accessor_storage, value, "f"); }
        /**
         * Determines if the notification includes a checkbox action.
         *
         * @attr {boolean} with-checkbox - If `true`, the notification includes a checkbox for user interaction. Defaults to `false`.
         */
        get withCheckbox() { return __classPrivateFieldGet(this, _SdsSystemNotification_withCheckbox_accessor_storage, "f"); }
        set withCheckbox(value) { __classPrivateFieldSet(this, _SdsSystemNotification_withCheckbox_accessor_storage, value, "f"); }
        async firstUpdated() {
            await this.updateComplete;
            appendStylesToTheStyleRoot(this, 'sds-system-notification', this._stylesGlobal.cssText);
        }
        render() {
            return html `
            <div class="${this.getClasses()}" part="sds-system-notification">
                <div class="sds-system-notification__content">
                    <slot name="content"></slot>
                </div>
                ${this.renderCheckboxButton()}
                <sds-button
                    @click="${() => this.close()}"
                    class="sds-system-notification__close"
                    type="tertiary"
                    size="md"
                    icon="close"
                ></sds-button>
            </div>
        `;
        }
        renderCheckboxButton() {
            return html `
            ${this.withButton || this.withCheckbox
                ? html ` <div class="sds-system-notification__action">
                      ${this.withCheckbox ? html `${this.renderCheckbox()}` : html ``}
                      ${this.withButton ? html `${this.renderButton()}` : html ``}
                  </div>`
                : html ``}
        `;
        }
        renderCheckbox() {
            return html ` <sds-checkbox label="Don’t show me again"></sds-checkbox> `;
        }
        renderButton() {
            return html `
            <sds-button label="Upgrade" type="primary"
                        size="md"></sds-button></div>
        `;
        }
        close() {
            this.remove();
        }
        getClasses() {
            return classMap({
                'sds-system-notification': true,
                'sds-system-notification--success': this.type === 'success',
                'sds-system-notification--info': this.type === 'info',
                'sds-system-notification--warning': this.type === 'warning',
                'sds-system-notification--error': this.type === 'error',
            });
        }
    };
    _SdsSystemNotification_type_accessor_storage = new WeakMap();
    _SdsSystemNotification_withButton_accessor_storage = new WeakMap();
    _SdsSystemNotification_withCheckbox_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSystemNotification");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [property({ type: String })];
        _withButton_decorators = [property({ type: Boolean, attribute: 'with-button' })];
        _withCheckbox_decorators = [property({ type: Boolean, attribute: 'with-checkbox' })];
        __esDecorate(_classThis, null, _type_decorators, { kind: "accessor", name: "type", static: false, private: false, access: { has: obj => "type" in obj, get: obj => obj.type, set: (obj, value) => { obj.type = value; } }, metadata: _metadata }, _type_initializers, _type_extraInitializers);
        __esDecorate(_classThis, null, _withButton_decorators, { kind: "accessor", name: "withButton", static: false, private: false, access: { has: obj => "withButton" in obj, get: obj => obj.withButton, set: (obj, value) => { obj.withButton = value; } }, metadata: _metadata }, _withButton_initializers, _withButton_extraInitializers);
        __esDecorate(_classThis, null, _withCheckbox_decorators, { kind: "accessor", name: "withCheckbox", static: false, private: false, access: { has: obj => "withCheckbox" in obj, get: obj => obj.withCheckbox, set: (obj, value) => { obj.withCheckbox = value; } }, metadata: _metadata }, _withCheckbox_initializers, _withCheckbox_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSystemNotification = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSystemNotification = _classThis;
})();
export { SdsSystemNotification };
